@if (claimListLoading) {
  <div class="progress-spinner-container">
    <mat-spinner
      class="progress-spinner"
      strokeWidth="10"
      [diameter]="100"
    ></mat-spinner>
  </div>
} @else if (claimListEmpty) {
  <div class="no-results">
    <mat-icon>search_off</mat-icon>
    <h4>{{ 'claims.noGrdpClaimsFound' | translate }}</h4>
  </div>
} @else {
  <itfg-data-table
    [data]="claimPage.content"
    [columns]="claimColumns"
    [isSortable]="true"
    [sortBy]="sortBy"
    (onSort)="sort($event)"
    [isClickable]="true"
  >
    <ng-template itfgDataTableTemplate="time" let-time="value">
      <itfg-date-format [date]="time"></itfg-date-format>
    </ng-template>
    <ng-template itfgDataTableTemplate="user" let-user="value">
      <a routerLink="/clients/{{ user.id }}" target="_blank">{{ user.id }}</a>
      / {{ user.fullName }}
    </ng-template>
    <ng-template itfgDataTableTemplate="completed" let-completed="value">
      <div [ngStyle]="{ 'padding-left': '20px' }">
        @if (completed) {
          <mat-icon
            class="completed-claim"
            [matTooltip]="'claims.completedStatus' | translate"
            >{{ 'check_circle' }}
          </mat-icon>
        }
        @if (!completed) {
          <mat-icon
            class="incomplete-claim"
            [matTooltip]="'claims.notCompletedStatus' | translate"
            >{{ 'cancel_circle' }}
          </mat-icon>
        }
      </div>
    </ng-template>
    <ng-template itfgDataTableTemplate="claimOption.name" let-claim="row">
      <span [matTooltip]="claim.claimOption?.code">{{
        claim.claimOption?.name
      }}</span>
    </ng-template>
    <ng-template itfgDataTableTemplate="completedAt" let-completedAt="value">
      <itfg-date-format [date]="completedAt"></itfg-date-format>
    </ng-template>
    <ng-template itfgDataTableTemplate="completedBy" let-completedBy="value">
      @if (completedBy) {
        <span [matTooltip]="completedBy.email">{{
          completedBy | administratorFullName
        }}</span>
      } @else {
        -
      }
    </ng-template>
    <ng-template itfgDataTableTemplate="actions" let-claim="row">
      <button
        mat-icon-button
        [disabled]="['CLAIM_WRITE'] | isUnauthorized | async"
        (click)="editClaim(claim)"
      >
        <mat-icon>edit</mat-icon>
      </button>
    </ng-template>
  </itfg-data-table>
}
<div [hidden]="claimListLoading || claimListEmpty">
  <mat-paginator
    #pagingBarResponsive
    (page)="pageChanged($event)"
    [pageIndex]="searchOptions.page"
    [length]="claimPage.totalElements"
    [pageSize]="searchOptions.pageSize"
    [pageSizeOptions]="[20, 30, 100]"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
